import {requirePermission} from '@/modules/auth/permissions'
import {UserGroupForm} from '@/modules/user-groups/components'
import {NewResourceFormContainer} from '@cypro/ui/components/ui/new-resource-form-container'
import {NewResourceFormHeader} from '@cypro/ui/components/ui/new-resource-form-header'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import * as z from 'zod'

const SearchSchema = z.object({
  groupId: z.string().optional(),
})

export const Route = createFileRoute('/configuration/user-groups/new')({
  beforeLoad: requirePermission('users.manage'),
  component: NewUserGroupPage,
  validateSearch: SearchSchema,
})

function NewUserGroupPage() {
  const {t} = useTranslate('user-groups')
  const {groupId} = Route.useSearch()

  return (
    <NewResourceFormContainer>
      <NewResourceFormHeader
        title={groupId ? t('edit_group_title') : t('new_group_title')}
        description={t('new_user_description')}
      />

      <UserGroupForm groupId={groupId} />
    </NewResourceFormContainer>
  )
}
